import { TutorialProps } from '@/services/tutorialService/tutorialTypes';
import { useLocalization } from '@/services/localizationService';

export const useSaveSettingsTutorial = ({
  setSaveSettingsDropdownOpen,
}: {
  setSaveSettingsDropdownOpen: (isOpen: boolean) => void;
}) => {
  const tutorialId = 'tutorial-save-settings';

  const { data } = useLocalization();

  const saveSettingsTutorialSteps: TutorialProps['steps'] = [
    {
      id: 'save-settings',
      description: data.result.tutorialSaveSettingsStepOne,
      index: 1,
      position: 'right',
      shouldExecuteBeforeNextStep: () => setSaveSettingsDropdownOpen(true),
    },
    {
      id: 'apply-to-all',
      description: data.result.tutorialSaveSettingsStepTwo,
      index: 2,
      position: 'right',
      shouldExecuteBeforePreviousStep: () => setSaveSettingsDropdownOpen(false),
      shouldExecuteBeforeNextStep: () => setSaveSettingsDropdownOpen(false),
    },
  ];

  return {
    saveSettingsTutorialId: tutorialId,
    saveSettingsTutorialSteps,
  };
};
